import React, { createContext, useContext, useMemo, useState } from "react";
import { useLoaderData } from "react-router";

import { ICOIInfo } from "../../../../../types/api";
import { AsyncStatuses } from "../../../../../types/shared";
import { CoiContextProps, CoiContextValues } from "../types/contexts";

const CoiContext = createContext<CoiContextValues | null>(null);

export const useCoiContext = () => {
    const context = useContext(CoiContext);
    if (!context) {
        throw new Error("useCoiContext must be used within a CoiProvider");
    }
    return context;
};

export const CoiProvider: React.FC<CoiContextProps> = props => {
    const { children, methods } = props;

    const { coi: loadedCOI } = useLoaderData() as { coi: ICOIInfo[] };
    const [fetchStatus, setFetchStatus] = useState<AsyncStatuses>("init");
    const [fileList, setFileList] = useState<File[]>([]);
    const [coi, setCoi] = useState<ICOIInfo | undefined>(loadedCOI[0]);

    const contextValue = useMemo(
        () => ({
            fetchStatus,
            setFetchStatus,
            fileList,
            setFileList,
            coi,
            setCoi,
            methods,
        }),
        [coi, fileList, fetchStatus],
    );

    return (
        <CoiContext.Provider value={contextValue}>
            {children}
        </CoiContext.Provider>
    );
};
